import React from 'react';
import { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
    Grid,
    Button,
    Box,
    Typography
} from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';

import CursosComplementares from './CursosComplementares';
const useStyles = makeStyles((theme) => ({
    paper: {
        marginTop: theme.spacing(1),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(2),
    },
    card: {
        marginTop: theme.spacing(2),
    },
}));

export default function FormCursosComplementares(props) {
    const classes = useStyles();
    const professionalProfile = props.professionalProfile.professionalProfile;
    const notFound = props.professionalProfile.professionalProfileNotFound;

    const [extraCurricularActivities, setExtraCurricularActivities] = useState([]);
    const [cursos, setCursos] = useState([]);

    function novoCurso() {
        let aux = [];
        const key = `nova${cursos.length + 1}`
        aux.push(
            <div className={classes.card} key={key}>
                <CursosComplementares
                    onSubmit={props.onSubmit}
                    onDelete={props.onDelete}
                />
            </div>
        )
        const newArray = cursos.concat(aux)
        setCursos([])
        setCursos(newArray);
    }

    React.useEffect(() => {
        let aux = [];
        extraCurricularActivities.map((extracurricularActivitie, index) => {
            aux.push(
                <div className={classes.card} key={`${extracurricularActivitie.title}${index}`}>
                    <CursosComplementares
                        extracurricularActivitie={extracurricularActivitie}
                        id={extracurricularActivitie.id}
                        onSubmit={props.onSubmit}
                        onDelete={props.onDelete}
                    />
                </div>
            )
        })
        if (aux.length === 0) {
            novoCurso()
        } else {
            setCursos(aux);
        }

    }, [extraCurricularActivities]);

    React.useEffect(() => {
        if (!notFound && professionalProfile.extracurricularActivities) {
            setExtraCurricularActivities(professionalProfile.extracurricularActivities);
        }
    }, [extraCurricularActivities])

    return (
        <>
            <div className={classes.paper}>
                <form className={classes.form} autoComplete="off">
                    <Grid item xs={12}>
                        <Box display="flex">
                            <Box flexGrow={1}>
                                <Typography variant="h6" component="p">
                                    Cursos Complementares
                                </Typography>
                            </Box>
                            <Box >
                                <Button size="small" onClick={() => novoCurso()}>Novo<AddIcon /></Button>
                            </Box>
                        </Box>
                    </Grid>
                    {cursos}
                </form>
            </div>
        </>
    );
}